import { ClipboardModule } from "@angular/cdk/clipboard";
import { DIALOG_DATA, Dialog, DialogModule, DialogRef } from "@angular/cdk/dialog";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ButtonConfig, Client, Job, VoyseComponent } from "@interfaces";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { calculateButtonClasses } from "src/app/helpers/buttons";
import { ApplyButtonComponent } from "src/app/page-components/apply-button/apply-button.component";
import { ReferButtonComponent } from "src/app/page-components/refer-button/refer-button.component";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { convertJobAddress } from "src/app/routes/jobs/job-helpers";
import { DialogContainerComponent } from "../../dialog-container/dialog-container.component";

@Component({
    selector: "voyse-job-dialog",
    templateUrl: "./job-dialog.component.html",
    standalone: true,
    imports: [
        CommonModule,
        ApplyButtonComponent,
        ReferButtonComponent,
        DialogModule,
        ClipboardModule,
        DialogContainerComponent,
    ],
    providers: [CurrencyPipe],
})
export class JobDialogComponent implements OnInit {
    public job: Job;
    public component: VoyseComponent;
    public panelOpenState = false;
    public locationString = "";
    public salaryString = "";
    public benefitsString = "";
    public applyButtonConfig: ButtonConfig = {
        textColour: "text-white",
        background: {
            type: "custom",
            value: "bg-blue-500",
        },
        textSize: "regular",
    };
    public referButtonConfig: ButtonConfig = {
        textColour: "text-black",
        background: {
            type: "custom",
            value: "bg-white",
        },
        textSize: "regular",
    };
    public shareButtonConfig: ButtonConfig = {
        textColour: "text-black",
        background: {
            type: "custom",
            value: "bg-white",
        },
        textSize: "regular",
        icon: "share",
    };
    public shareButtonClasses = calculateButtonClasses(this.shareButtonConfig);

    public client: Client;
    public hideActions = false;

    constructor(
        private currency: CurrencyPipe,
        private gtag: GtagService,
        private subdomain: SubdomainService,
        private dialog: Dialog,
        public dialogRef: DialogRef<JobDialogComponent>,
        @Inject(DIALOG_DATA) public data
    ) {
        this.job = data.job;
        this.component = data.component;
    }

    ngOnInit() {
        this.subdomain.getClient().subscribe((value: Client) => {
            this.client = value;
        });
        const formattedAddress = convertJobAddress(this.job.locationMeta);
        this.locationString =
            this.job.locationLabel ||
            formattedAddress?.addressLocality ||
            formattedAddress?.addressRegion ||
            this.job.location;
        if (this.job?.salary?.label) {
            this.salaryString = this.job?.salary?.label;
        } else if (this.job?.salary?.from && this.job.salary?.to) {
            this.salaryString = `${this.currency.transform(
                this.job.salary.from,
                this.job.salary.currency
            )} - ${this.currency.transform(this.job.salary.to, this.job.salary.currency)} ${this.job.salary.type}`;
        }
        if (this.job?.benefits?.length) {
            this.benefitsString = this.job.benefits.join(", ");
        }
    }

    public recordShareEvent(platform: string) {
        this.gtag.fireShareEvent(platform);
    }

    public shareJob() {
        // Check if navigator.share is supported
        if (navigator?.share) {
            navigator
                .share({
                    title: this.job.title,
                    text: this.job.content.en,
                    url: window.location.href,
                })
                .then(() => {
                    this.recordShareEvent("navigator.share");
                })
                .catch((error) => {
                    console.log("Error sharing", error);
                });
        } else {
            // Fallback to copy to clipboard via cdk clipboard
            const url = window.location.href;
            navigator.clipboard.writeText(url).then(() => {
                this.recordShareEvent("navigator.clipboard");
            });
            alert(`Copied job link to clipboard.`);
        }
    }

    public copyToClipboard() {
        // Fallback to copy to clipboard via cdk clipboard
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(() => {
            this.recordShareEvent("navigator.clipboard");
        });
        alert(`Copied job link to clipboard.`);
    }

    public close() {
        this.dialogRef.close();
    }
}
